import {
  ChatWithDataChartArtifact,
  ChatWithDataMessageRole,
  ChatWithDataMinMaxProposal,
  ChatWithDataTableArtifact,
  ChatWithDataToolName,
} from '@recurrency/core-api-schema/dist/chatWithData/chatWithData';

export enum ContentBlockType {
  Text = 'text',
  Tool = 'tool',
  Table = 'table',
  Chart = 'chart',
  MinMaxProposal = 'minMaxProposal',
}

export enum ToolBlockStatus {
  Running = 'running',
  Done = 'done',
}

export type ContentBlock =
  | { type: ContentBlockType.Text; text: string }
  | { type: ContentBlockType.Tool; name: ChatWithDataToolName; status: ToolBlockStatus }
  | { type: ContentBlockType.Table; table: ChatWithDataTableArtifact }
  | { type: ContentBlockType.Chart; chart: ChatWithDataChartArtifact }
  | { type: ContentBlockType.MinMaxProposal; proposal: ChatWithDataMinMaxProposal };

/** Parsed file data sent to the backend. Mirrors ChatWithDataFileData in core-api. */
export interface ChatWithDataFileData {
  fileName: string;
  columns: string[];
  rows: (string | number | boolean | null)[][];
}

export interface ChatMessage {
  id: string;
  role: ChatWithDataMessageRole;
  /** User messages */
  content?: string;
  timestamp: Date;
  /** Display-only: name of the file the user attached (persisted to localStorage). */
  fileName?: string;
  /** Ordered content blocks for assistant messages */
  blocks?: ContentBlock[];
  activeToolName?: ChatWithDataToolName;
  /** Whether the assistant response fully completed. */
  done?: boolean;
}

export interface StoredConversation {
  /** Local id; the per-conversation storage key and the sidebar key. */
  id: string;
  /** Backend session id, replayed to continue server-side context. */
  sessionId?: string;
  /** Auto-derived from the first user message unless the user renamed it. */
  title: string;
  /** True once the user renames it, so the auto-title stops overwriting it. */
  isTitleCustom?: boolean;
  /** ISO strings — JSON has no Date type. */
  createdAt: string;
  updatedAt: string;
  messages: ChatMessage[];
}

/** Metadata-only view for the conversation list (no messages). */
export interface ConversationSummary {
  id: string;
  title: string;
  createdAt: string;
  updatedAt: string;
  sessionId?: string;
}
